import useAppService from './useAppService.js';

function useConfig() {
    const appService = useAppService();
    return appService.config; // it's a mobx-observable now, but pls don't abuse
}

export { useConfig as default };
//# sourceMappingURL=useConfig.js.map
